import { Avatar } from '@commenda/kakashi';

type ChatAvatarSize = 'sm' | 'lg';

type ChatAvatarProps = {
  name?: string;
  image?: string;
  size: ChatAvatarSize;
  /** Stable user id for the deterministic color; falls back to name (e.g. for
   * external users that have no id). */
  colorSeed?: string | number;
};

// Chat uses two semantic sizes; map them onto the shared Avatar scale
// (sm → 24px, lg → 32px). Color is derived deterministically from the seed.
const SIZE_MAP: Record<ChatAvatarSize, 'xs' | 'sm'> = {
  sm: 'xs',
  lg: 'sm',
};

const ChatAvatar = ({ name, image, size, colorSeed }: ChatAvatarProps) => (
  <Avatar
    size={SIZE_MAP[size]}
    name={name}
    image={image}
    colorSeed={colorSeed ?? name}
  />
);

export default ChatAvatar;
